import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  computerMove: '',
  guide: '',
  expected: { rank: null, suit: null }, // expected player options
  draw: 1,
  locked: false // use to freeze user input
};

const infoSlice = createSlice({
  name: 'info',
  initialState,
  reducers: {
    setComputerMove(state, action) {
      state.computerMove = action.payload;
    },
    setGuide(state, action) {
      state.guide = action.payload;
    },
    setDraw(state, action) {
      state.draw = action.payload;
    },
    setExpected(state, action) {
      state.expected = action.payload;
    },
    setLock(state, action) {
      state.locked = true;
    },
    clearLock(state, action) {
      state.locked = false;
    },
    resetInfo(state, action) {
      // state = { ...initialState, expected: { ...initialState.expected } };
      state.computerMove = '';
      state.guide = '';
      state.draw = 1;
      state.expected = { rank: null, suit: null };
      state.locked = false;
    }
  }
});

// Action creators are automatically generated by the slice.
export const { setComputerMove, setGuide, setDraw, setExpected,
  setLock, clearLock, resetInfo } = infoSlice.actions;
export const getComputerMove = (state) => state.info.computerMove;
export const getGuide = (state) => state.info.guide;
export const getDraw = (state) => state.info.draw;
export const getExpected = (state) => state.info.expected;
export const getLock = (state) => state.info.locked;

export default infoSlice.reducer;